var map = {
	"./1.mp3": 8798,
	"./10.mp3": 1234,
	"./11.mp3": 8903,
	"./12.mp3": 3712,
	"./15.mp3": 4995,
	"./16.mp3": 5244,
	"./17.mp3": 4193,
	"./18.mp3": 5738,
	"./19.mp3": 4703,
	"./20.mp3": 4691,
	"./21.mp3": 6302,
	"./23.mp3": 876,
	"./24.mp3": 7511,
	"./25.mp3": 2578,
	"./26.mp3": 5557,
	"./27.mp3": 2576,
	"./28.mp3": 2587,
	"./29.mp3": 7750,
	"./3.mp3": 5948,
	"./30.mp3": 2220,
	"./31.mp3": 8993,
	"./32.mp3": 3054,
	"./33.mp3": 3555,
	"./5.mp3": 4450,
	"./6.mp3": 8981,
	"./7.mp3": 8240,
	"./8.mp3": 6011,
	"./9.mp3": 9686
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6981;